
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, X } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { AdminFiltersProps } from './types';

const AdminFilters = ({
  filterText,
  setFilterText,
  roleFilter,
  setRoleFilter,
  roles
}: AdminFiltersProps) => {
  const handleClearFilters = () => {
    setFilterText('');
    setRoleFilter('all-roles');
  };

  const isFilterActive = filterText !== '' || roleFilter !== 'all-roles';

  return (
    <div className="mb-6 space-y-4">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1 relative">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search administrators..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            className="pl-8"
          />
          {filterText && (
            <Button
              variant="ghost"
              size="sm"
              className="absolute right-1 top-1.5 h-7 w-7 p-0"
              onClick={() => setFilterText('')}
            >
              <X className="h-4 w-4" />
              <span className="sr-only">Clear search</span>
            </Button>
          )}
        </div>
        <div className="w-full md:w-64">
          <Select
            value={roleFilter}
            onValueChange={setRoleFilter}
          >
            <SelectTrigger>
              <SelectValue placeholder="Filter by role" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all-roles">All Roles</SelectItem>
              {roles.map(role => (
                <SelectItem key={role} value={role}>{role}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        {isFilterActive && (
          <Button variant="outline" onClick={handleClearFilters} className="shrink-0">
            Clear Filters
          </Button>
        )}
      </div>
    </div>
  );
};

export default AdminFilters;
